import { Controller } from "@hotwired/stimulus";
import { Modal } from "bootstrap";
import { internalApiClient } from "../src/libs/axios/internalApiClient";

export default class extends Controller {
  static values = { param: String, jobKey: String };
  static targets = ["tweetButton"];

  declare paramValue: string;
  declare hasParamValue: boolean;
  declare jobKeyValue: string;
  declare hasJobKeyValue: boolean;
  declare tweetButtonTarget: HTMLButtonElement;

  private _onHidden?: () => void;
  private isSubmitting = false;

  connect(): void {
    this.showIfSetParams();

    // モーダルを閉じた時に自動で表示されないように、クエリパラメータを削除する
    this._onHidden = () => { this.clearQuery(); };
    this.element.addEventListener("hidden.bs.modal", this._onHidden);
  }

  disconnect(): void {
    if (!this._onHidden) return;
    this.element.removeEventListener("hidden.bs.modal", this._onHidden);
  }

  showIfSetParams(): void {
    if (!this.hasParamValue) return;

    const params = new URLSearchParams(window.location.search);
    const val = (params.get(this.paramValue) ?? "").toLowerCase();
    if (val !== "true") return;

    Modal.getOrCreateInstance(this.element).show();
  }

  async tweet(): Promise<void> {
    if (this.isSubmitting) return;
    if (!this.hasJobKeyValue) {
      console.error("[tweet] jobKeyが存在しません。");
      return;
    }

    // ボタンをローディング表示にするためにHTML・CSSを上書きする
    // API通信完了後にfinallyで元に戻す必要がある
    const originalContent = this.tweetButtonTarget.innerHTML;
    const originalMinWidth = this.tweetButtonTarget.style.minWidth;
    this.tweetButtonTarget.style.minWidth = `${this.tweetButtonTarget.offsetWidth}px`;
    this.tweetButtonTarget.disabled = true;
    this.tweetButtonTarget.innerHTML = '<span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>送信中...';

    this.isSubmitting = true;
    try {
      const { data } = await internalApiClient.post(`/api/internal/v1/jobs/${this.jobKeyValue}/tweet`);
      this.clearQuery();
      Modal.getInstance(this.element)?.hide();
      this.showDoneModal(data.tweetUrl);
    } catch {
      alert("つぶやきの投稿に失敗しました。時間をおいて再度お試しください。");
    } finally {
      this.tweetButtonTarget.innerHTML = originalContent;
      this.tweetButtonTarget.style.minWidth = originalMinWidth;
      this.tweetButtonTarget.disabled = false;
      this.isSubmitting = false;
    }
  }

  private showDoneModal(tweetUrl: string | undefined): void {
    const doneModal = document.getElementById("postTweetDoneModal")!;
    const link = document.getElementById("postTweetDoneLink") as HTMLAnchorElement | null;
    if (link && tweetUrl) {
      link.href = tweetUrl;
    }
    Modal.getOrCreateInstance(doneModal).show();
  }

  clearQuery(): void {
    if (!this.hasParamValue) return;

    const url = new URL(window.location.href);
    url.searchParams.delete(this.paramValue);
    window.history.replaceState({}, "", url.toString());
  }
}
